import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchExpensesExportComponent } from './branch-expenses-export.component';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    BranchExpensesExportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule
  ],
  exports: [
    BranchExpensesExportComponent
  ]
})
export class BranchExpensesExportModule { }
